import { useSearchParams } from 'react-router';
import { useFeature } from '@modules/root';
import { CATEGORY_REVAMP_FEATURE_KEY } from '@modules/category/util/category-revamp-flag';

/**
 * Whether the 2026 category-pages carousel browse revamp is active for this
 * request: the category_pages_revamp_2026 flag (including the tester URL/session
 * toggle), or the dev-only `?categoryRevamp=` override (`1` on, `0` off) for
 * previewing locally regardless of the DB flag. Mirrors isCategoryRevampActive
 * for client components.
 */
export const useCategoryRevamp = (): boolean => {
    const enabled = useFeature(CATEGORY_REVAMP_FEATURE_KEY);
    const [searchParams] = useSearchParams();
    if (import.meta.env.DEV) {
        const override = searchParams.get('categoryRevamp');
        if (override === '0') {
            return false;
        }
        if (override === '1') {
            return true;
        }
    }
    return enabled;
};
